// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Login_errorMessage__G7KCX","socialButtons":"Login_socialButtons__xu7ms","icon":"Login_icon__1IEI-"};